// ModalPopup.tsx
import React, { useEffect, useRef, useContext } from "react";
// @ts-ignore
import { LocalizationContext } from "react-localize";
import "./travelex.sass";
import travelexClose from "./static/images/modal-close.png";

interface ModalPopupProps {
  description?: string;
  onClose: () => void;
  onYes: () => void;
}

const TravelInsurenceConfirmModal: React.FC<ModalPopupProps> = ({
  onClose,
  onYes,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const { localize }: any = useContext(LocalizationContext);

  const header = localize("static.content.third-party-modal-title");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="close-button" onClick={onClose}>
          <img src={travelexClose} alt="close Logo" />
        </div>
        <div className="travelex-modal-body">
          <div className="travelex-modal-title">{header}</div>
          <div className="travelex-modal-info">
            {localize("static.content.third-party-modal-description")}
          </div>
        </div>
        <div className="travelex-modal-btn-container">
          <button className="yes-button" onClick={onYes}>
            {localize("static.content.yes-button-label")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TravelInsurenceConfirmModal;
